import Profile from '@components/match/profile';
import MatchingBanner from '@components/match/MatchingBanner';
import MatchTab from '@components/match/matchTab';
import { getAccessToken } from '@repository/AccessToken';
import MatchDashboardModals from '@components/match/matchDashboard/modals';
import { ContentRouteUtil, V2RouteUrl } from '@utils/routeUtil';
import useOnMount from '@utils/hooks/useOnMount';
import classnames from 'classnames/bind';
import styles from './matchDashboard.module.scss';
const cx = classnames.bind(styles);

const MatchDashboard = () => {
  useOnMount(() => {
    // 미 로그인 상태로 접근시 로그인 페이지로 이동
    if (!getAccessToken()) {
      ContentRouteUtil.goLoginPage(V2RouteUrl.MATCH_APPLY);
    }
  });

  return (
    <div className={cx('matchPageArea')}>
      <div className={cx('container')}>
        <section>
          <Profile />
        </section>
        <section>
          <MatchingBanner size="small" />
          <MatchTab />
        </section>
      </div>

      <MatchDashboardModals />
    </div>
  );
};

export default MatchDashboard;
